import { BaseIconProps } from "../../types/styles";

const SagittalViewIcon = ({
    id,
    className,
    size = 32,
    customColor,
    ...rest
}: BaseIconProps) => {
    const color = customColor ?? "var(--color-white)";

    return (
        <svg
            {...rest}
            id={id ? `icon-${id}` : "icon-saggital"}
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
        >
            <path
                d="M29.6667 21L16.3333 29.6667L16.3333 21L23 16.3333L29.6667 21Z"
                fill={color}
            />
            <path
                d="M29.6667 11.6667V21L23 16.3333L29.6667 11.6667Z"
                fill={color}
            />
            <path
                d="M29.6667 11.6667V21L16.3333 29.6667L3 21V11.6667L16.3333 3L29.6667 11.6667ZM3 11.6667L16.3333 21M16.3333 29.6667L16.3333 21M29.6667 21L23 16.3333M29.6667 11.6667L16.3333 21M16.3333 21L23 16.3333L29.6667 11.6667"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SagittalViewIcon;
